var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuseSpurForTowelRail01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.4,3v5h5.3C10.4,5.2,8.1,3.1,5.4,3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.4,
    y1: 8,
    x2: 10.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.4,8c-0.1,1.4-0.7,2.8-1.8,3.7c-0.9,0.7-2,1.2-3.1,1.2V8.1L10.4,8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuseSpurForTowelRail01);
export default __webpack_public_path__ + "static/media/FuseSpurForTowelRail-01.100585da8e9c5d694f76024ae21c4853.svg";
export { ForwardRef as ReactComponent };